'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
require('../../hooks/useNotification.js');
var usePrevious = require('../../hooks/usePrevious.js');
require('../../hooks/useSort.js');
var MultiSelectMenu = require('../MultiSelectMenu/MultiSelectMenu.js');
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var fmPrefix = 'componentLib.appWide';
var ConfirmationSelectMenu = function (props) {
    var title = props.title, reporter = props.reporter, initiallySelected = props.initiallySelected;
    var fm = reactIntl.useIntl().formatMessage;
    var menuItems = [
        {
            value: 'yes',
            display: fm({ id: fmPrefix + ".yes" }),
        },
        {
            value: 'no',
            display: fm({ id: fmPrefix + ".no" }),
        },
    ];
    var _a = React.useState(initiallySelected || []), initiallySelectedValue = _a[0], setInitiallySelectedValue = _a[1];
    var _b = React.useState(false), forceRender = _b[0], setForceRender = _b[1];
    var prevInitiallySelectedValue = usePrevious(initiallySelected);
    React.useEffect(function () {
        if (prevInitiallySelectedValue &&
            !utils.isArrayEq(prevInitiallySelectedValue, initiallySelectedValue)) {
            setInitiallySelectedValue(initiallySelected);
            setForceRender(true);
        }
    }, [initiallySelectedValue]);
    React.useEffect(function () {
        setForceRender(false);
    }, [forceRender]);
    return (React__default.createElement(styledComponents.RootContainer, null,
        React__default.createElement(styledComponents.TitleContainer, null, title),
        React__default.createElement(styledComponents.SelectContainer, null, !forceRender && (React__default.createElement(MultiSelectMenu, { initiallySelected: initiallySelectedValue, menuItems: menuItems, title: title, reporter: reporter })))));
};

module.exports = ConfirmationSelectMenu;
